module.exports = __webpack_public_path__ + "static/media/warning-modal-icon.456bb38c.svg";